import React from "react";
import VideoPlayer from "components/video-player";

const VideoSection = ({ data }) => {
  return (
    <div className="">
      <div className="my-9 sm:my-6 h-[600px] sm:h-72">
        <VideoPlayer videoLink={data.video.video} />
      </div>
    </div>
  );
};

export default VideoSection;
